import React, { useCallback, useEffect, useState } from 'react'

import FormInfo from 'components/DueDiligenceList/FormInfo'
import ManualAnalysisList from 'components/ManualAnalysisList'
import { useLocation } from 'react-router'
import { Expansible } from 'components/Expansible'
import AdditionalQuestionForm from 'components/AdditionalQuestionForm'
import ApplicantInfo from 'components/ApplicantInfo'
import TableLoadingAnimation from 'components/TableLoadingAnimation'
import AutomaticQuestions from 'components/ProspectDashboard/AutomaticQuestions'
import AdditionalQuestionInfo from 'components/ProspectDashboard/AdditionalQuestionInfo'

import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { getApplicationById, getApplicationOpenQuestions, getApplicationReviews, getExtraAutomaticQuestions } from 'services/apiKYP'


import styles from './styles'

function ApplicationReview() {
  const location = useLocation()
  const classes = styles()
  const queryParameters = new URLSearchParams(location.search)
  const application_uuid = queryParameters.get('application_uuid')
  
  const token = useSelector((state) => state.auth.access_token)

  const [loading, setLoading] = useState(false)
  const [loadingReview, setLoadingReview] = useState(false)
  const [reviewsList, setReviewList] = useState([])
  const [applicationData, setApplicationData] = useState({})
  const [automaticQuestions, setAutomaticQuestions] = useState([])
  const [openQuestions, setOpenQuestions] = useState([])

  const loadApplicationData = useCallback(async () => {
    setLoading(true)
    getApplicationById(token, application_uuid)
      .then((response) => {
        setApplicationData(response.data)
      })
      .catch(() => {
        toast.error('Houve um problema ao obter os dados da aplicação')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [token, application_uuid])

  const loadReviewData = () => {
    setLoadingReview(true)
    getApplicationReviews(token, application_uuid)
      .then((response) => {
        setReviewList(response.data)
      })
      .catch(() => {
        toast.error()
      })
      .finally(() => {
        setLoadingReview(false)
      })
  }
  
  const loadAutomaticExtraQuestions = () => {
    if (application_uuid !== '') {
      getExtraAutomaticQuestions(token, application_uuid)
        .then((response) => {
          setAutomaticQuestions(response.data)
        })
        .catch(() => {
          toast.error('Houve um erro ao obter os esclarecimentos adicionais')
        })
    }
  }
  
  const loadOpenExtraQuestions = () => {
    if (application_uuid !== '') {
      getApplicationOpenQuestions(token, application_uuid)
        .then((response) => {
          setOpenQuestions(response.data)
        })
        .catch(() => {
          toast.error('Houve um erro ao obter as perguntas adicionais')
        })
    }
  }

  useEffect(() => {
    loadApplicationData()
    loadAutomaticExtraQuestions()
    loadOpenExtraQuestions()
    loadReviewData()
  }, [])

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <header className={classes.header}>
          <h1>Análise manual</h1>
          <p>
            Nesta tela você poderá ter uma visão mais detalhada da aplicação do
            candidato, solicitar esclarecimentos sobre um tópico específico e
            visualizar respostas adicionais do usuário, além de fazer a análise
            manual para a aprovação ou reprovação do mesmo.
          </p>
        </header>
        {loading ? (
          <TableLoadingAnimation />
        ) : (
          <div className={classes.wrapper}>
            <section className={classes.section}>
              <h2 className={classes.title}>Dados do aplicante</h2>
              <ApplicantInfo
                applicantData={applicationData?.prospect?.person}
              />
            </section>
            <section className={classes.section}>
              <h2 className={classes.title}>
                Due Diligence, perguntas automáticas e perguntas adicionais
              </h2>
              <Expansible title="Respostas do formulário de Due Diligence">
                <FormInfo
                  id={applicationData?.form?.uuid}
                  showPersonInfo={false}
                />
              </Expansible>
              <Expansible title="Respostas das perguntas automáticas">
                <AutomaticQuestions questions={automaticQuestions} />
              </Expansible>
              <Expansible title="Respostas das perguntas adicionais">
                <AdditionalQuestionInfo questions={openQuestions} reloadData={loadOpenExtraQuestions}/>
              </Expansible>
            </section>
            <section className={classes.section}>
              <h2 className={classes.title}>
                Solicitar esclarecimento adicional
              </h2>
              <AdditionalQuestionForm applicationUuid={application_uuid || ''} />
            </section>
            {!loadingReview && reviewsList?.length > 0 ? (
              <section className={classes.section}>
                <h2 className={classes.title}>Análises manuais</h2>
                <ManualAnalysisList issuesList={reviewsList} />
              </section>
            ) : null}
          </div>
        )}
      </div>
    </div>
  )
}

export default ApplicationReview
